function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.8 10.7V5.4c0-.7-.5-1.2-1.2-1.2h-2.5l-.4-1.1c-.1-.3-.4-.5-.7-.5H8c-.3 0-.6.2-.7.5l-.5 1.1H4.4c-.7 0-1.2.5-1.2 1.2v5.3c-2.1.6-3.2 1.5-3.2 2.6 0 2.2 4.5 3.4 9.1 3.5l-.9.9c-.2.1-.2.3-.2.4 0 .1.1.2.3.3.1 0 .3 0 .4-.1l1.6-1.6c.2-.2.2-.4 0-.6l-1.6-1.6c-.2-.1-.4-.1-.6 0-.1.2-.1.5 0 .6l.9.9C4.1 15.8.8 14.5.8 13.3c0-.6.9-1.3 2.4-1.8v1c0 .7.5 1.2 1.2 1.2h11.2c.7 0 1.2-.5 1.2-1.2v-1c1.5.5 2.4 1.2 2.4 1.8 0 1.1-2.9 2.5-7.6 2.7-.2 0-.4.2-.4.4s.2.4.4.4c4-.2 8.4-1.4 8.4-3.5 0-1.1-1.1-2-3.2-2.6zm-6.8.6c-1.5 0-2.8-1.2-2.8-2.8C7.2 7 8.5 5.8 10 5.8s2.8 1.2 2.8 2.8c0 .7-.3 1.4-.8 2-.5.4-1.3.7-2 .7zm4.8-4.7c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.2.4-.4.4z"
});

function SvgRotateCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default SvgRotateCamera;